import { enConfiguredEnums, enEnums } from "./enum.en"

export const en = {
  ...enEnums,
  ...enConfiguredEnums,
  "InstallmentSpecification.amount": "Amount",
  "InstallmentSpecification.dueDate": "Due date",
  "action.addAnnotation": "Add annotation",
  "action.addBalancePosting.field.accountType": "Account type",
  "action.addBalancePosting.field.amount": "Amount",
  "action.addBalancePosting.field.balancePostingSpecs": "Balance posting specs",
  "action.addBalancePosting.field.changeDate": "Change date",
  "action.addBalancePosting.field.coverKey": "Cover key",
  "action.addBalancePosting.field.fraction": "Fraction",
  "action.addBalancePosting.field.fractionBalancePostingSpecs": "Fraction balance posting specs",
  "action.addBalancePosting.field.policeKey": "Policy key",
  "action.addBalancePosting.field.postingType": "Posting type",
  "action.addBalancePosting.title": "Balance posting",
  "action.addFractionBalancePosting.title": "Fraction balance posting",
  "action.addPayableStop.title": "Add payable stop",
  "action.addPaymentChannel._type": "Account type",
  "action.addPaymentChannel.accountSelection": "Account",
  "action.addPaymentChannel.addAccount": "Add account",
  "action.addPaymentChannel.applyDate": "Apply date",
  "action.addPaymentChannel.currencyCode": "Currency code",
  "action.addPaymentChannel.paymentChannelCriteria": "Payment channel criteria",
  "action.addPaymentChannel.paymentChannelCriteriaElement": "Payment channel criteria",
  "action.addPaymentChannel.title": "Add payment channel",
  "action.amendAnnotation": "Amend annotation",
  "action.annotation.title": "Annotation",
  "action.changeAddress.button": "Address",
  "action.createInvoice.billingMethodType": "Billing method type",
  "action.createInvoice.externalPostingType": "External posting type",
  "action.createInvoice.internalPaymentDueDate": "Internal payment due date",
  "action.createInvoice.invoiceStatus": "Invoice status",
  "action.createInvoice.invoiceStrategyId": "Invoice strategy ID",
  "action.createInvoice.invoiceType": "Invoice type",
  "action.createInvoice.lastOperationDate": "Last operation date",
  "action.createInvoice.lastOperationId": "Last operation ID",
  "action.createInvoice.paidAmount": "Paid amount",
  "action.createInvoice.paymentDueDate": "Payment due date",
  "action.createInvoice.suspensionDate": "Suspension date",
  "action.createInvoice.suspensionReason": "Suspension reason",
  "action.createInvoice.title": "New invoice",
  "action.createPaymentReceiver.applyDate": "Apply date",
  "action.createPaymentReceiver.title": "Create payment receiver",
  "action.creditPaymentInvoice.paymentDate": "Payment date",
  "action.creditPaymentInvoice.title": "Credit payment invoice",
  "action.deletePayableStop.title": "Delete payable stop",
  "action.deletePaymentChannel.input.applyDate": "Apply date",
  "action.deletePaymentChannel.title": "Delete payment channel",
  "action.disablePenaltiesInvoice": "Disable penalties on invoice",
  "action.editPayableStop.title": "Edit payable stop",
  "action.editPaymentChannel.applyDate": "Apply date",
  "action.editPaymentChannel.channelId": "Payment channel",
  "action.editPaymentChannel.title": "Edit payment channel",
  "action.invoicePaymentWithdrawal.disabledDueToManualWriteOffAvailable": "Cannot withdraw a regular payment while a manual write-off payment exists",
  "action.invoicePaymentWithdrawal.disabledDueToWriteOff": "Payment has been written off",
  "action.invoicePaymentWithdrawal.input.newDueDate": "New due date",
  "action.invoicePaymentWithdrawal.input.nextOperationDate": "Next operation date",
  "action.invoicePaymentWithdrawal.input.nextOperationId": "Next operation ID",
  "action.invoicePaymentWithdrawal.title": "Withdraw payment from invoice",
  "action.pauseInvoice": "Pause invoice",
  "action.payableStop.addText": "Add reason",
  "action.payableStop.applyDate": "Apply date",
  "action.payableStop.payableStopType": "Type",
  "action.payableStop.stopId": "Payable stop",
  "action.payableStop.text": "Reason",
  "action.removeAnnotation": "Remove annotation",
  "action.resumeInvoice": "Resume invoice",
  "action.retirement": "Retirement",
  "action.retirement.input.retirementDate": "Retirement date",
  "action.retirement.input.retirementFraction": "Retirement fraction",
  "action.setDefaultPaymentChannel.applyDate": "Apply date",
  "action.setDefaultPaymentChannel.title": "Set default payment channel",
  "action.testFullTradeCycle.title": "TEST COMMAND - Full trade cycle",
  "actionReasonCode.approvePendingCancellationAlreadyPending": "Cancellation-approval already pending",
  "actionReasonCode.insufficientAccess": "Insufficient access",
  "actions.addManualInvoice": "Manual invoice",
  "actions.createInstallmentPlan": "Instalment plan",
  "actions.setLegalentityStopFlags": "Legalentity: stop",
  "actions.setLifeStopFlags": "Life: stop",
  "actions.setUnitlinkStopFlags": "UnitLink: stop",
  "actions.viewInvoiceElements": "View invoice elements",
  "actions.writeOffInvoice.paymentDate": "Payment date",
  "actions.writeOffInvoice.title": "Write off invoice",
  "actions.writeOffInvoice.writeOffCategory": "Write off category",
  "activeRecurringMoneyOutVersionDetails.lifeDependent": "Life dependant",
  "activeRecurringMoneyOutVersionDetails.moneyOutEndDate": "Money out end",
  "activeRecurringMoneyOutVersionDetails.moneyOutLength": "Money out length",
  "activeRecurringMoneyOutVersionDetails.moneyOutStart": "Money out start",
  "activeRecurringMoneyOutVersionDetails.moneyOutTaxCode": "Money out tax code",
  "activeRecurringMoneyOutVersionDetails.moneyOutType": "Money out type",
  "activeRecurringMoneyOutVersionDetails.payoutAmount": "Payout amount",
  "activeRecurringMoneyOutVersionDetails.receiverPersonId": "Receiving person ID",
  "activeRecurringMoneyOutVersionDetails.relationshipType": "Relationship type",
  "addBankAccountModal.title": "Add bank account",
  "addFundMergeCommandData.fromDate": "Effective date",
  "addFundMergeCommandData.fundMerge.date": "Portfolio effective date",
  "addFundMergeCommandData.fundMergedestinationIsinKey": "Destination ISIN key",
  "addFundMergeCommandData.isinKey": "ISIN key",
  "address.addresses": "Addresses",
  "address.city": "City",
  "address.country": "Country",
  "address.field._type": "Type",
  "address.field.abbreviatedCountryName": "Country code",
  "address.field.addressCo": "Temporary address",
  "address.field.addressLine1": "Line 1",
  "address.field.addressLine2": "Line 2",
  "address.field.addressLine3": "Line 3",
  "address.field.city": "City",
  "address.field.country": "Country",
  "address.field.houseNumber": "House number",
  "address.field.isValid": "Is valid",
  "address.field.numericalCountryCode": "Country name",
  "address.field.postalCode": "Postal code",
  "address.field.relocationDate": "Relocation date",
  "address.field.relocationInformationReceiveDate": "Relocation information receive date",
  "address.field.streetName": "Street name",
  "address.postalCode": "Postal code",
  "addressCard.address1": "Address 1",
  "addressCard.address2": "Address 2",
  "addressCard.address3": "Address 3",
  "addressCard.addressType": "Address type",
  "addressCard.city": "City",
  "addressCard.country": "Country",
  "addressCard.postalCode": "Postal code",
  "addressCard.title": "Address",
  "addressLink.field.addressLink": "Address",
  "addressLink.field.addressLinks": "Addresses",
  "addressLink.field.addressType": "Address type",
  "advancedSearchCard.companyTab": "Company",
  "advancedSearchCard.internalAndExternalIdLookupTab": "Internal or external ID lookup",
  "advancedSearchCard.internalIdLookupTab": "Internal ID lookup",
  "advancedSearchCard.personTab": "Person",
  "agreements.noAgreement": "agreement",
  "agreements.noAppliedEvents.reason": "Please select an unapplied event to see data.",
  "agreements.noEventSelected": "event selected.",
  "agreements.noEventSelected.reason": "Please select an event to see data.",
  "agreementsSection.title": "Agreements",
  "ai.agent.activity.ranCommand": "Ran {count} command",
  "ai.agent.activity.ranCommands": "Ran {count} commands",
  "ai.agent.activity.usingTool": "Using tool",
  "ai.agent.chat.close": "Close chat",
  "ai.agent.chat.input.placeholder": "Ask a question...",
  "ai.agent.chat.intro": "Hi! I'm your AI assistant. How can I help you with this commitment?",
  "ai.agent.chat.message.error": "Failed to send",
  "ai.agent.chat.retry": "Retry",
  "ai.agent.chat.send": "Send",
  "ai.agent.chat.toggle": "Open AI chat",
  "ai.agent.chat.typing": "Assistant is typing…",
  "ai.commitment.summary": "AI Summary",
  "ai.commitment.summary.error": "The AI summary could not be completed.",
  "amendEmployerAgreementPolicies.label": "Amend policies",
  "amendEmployerAgreementPolicies.title": "Amend policies",
  "amendEmployerAgreementPoliciesForm.actionOption": "Action option",
  "amendEmployerAgreementPoliciesForm.adjustSalaryFromContribution": "Adjust salary from contribution",
  "amendEmployerAgreementPoliciesForm.applyDate": "Apply date",
  "amendEmployerAgreementPoliciesForm.policyDefaultSelected": "Policy default selected",
  "amendEmployerAgreementPoliciesForm.subTemplateIdentifier": "Subtemplate ID",
  "amendEmployerAgreementPolicy.elementLabel": "Amend policy",
  "amountCreation.amountPerInstallment": "Amount per instalment",
  "amountCreation.dueDate": "Due date",
  "amountSpecVersionDetails.currentAmount": "Current amount",
  "amountSpecVersionDetails.currentAmountDocumentation": "Current amount documentation",
  "amountSpecVersionDetails.fraction": "Fraction",
  "amountSpecVersionDetails.fractionDocumentation": "Fraction documentation",
  "amountSpecVersionDetails.parameterAmount": "Parameter amount",
  "amountSpecVersionDetails.parameterAmountDocumentation": "Parameter amount documentation",
  "amountSpecVersionDetails.parameterKey": "Parameter key",
  "amountSpecVersionDetails.parameterKeyDocumentation": "Parameter key documentation",
  "amountSpecVersionDetails.parameterValue": "Parameter value",
  "amountSpecVersionDetails.parameterValueDocumentation": "Parameter value documentation",
  "annotation.accessGroupAnnotation.group": "Access group",
  "annotation.applyDate": "Apply date",
  "annotation.groups.group": "Group",
  "annotation.groups.title": "Annotation groups",
  "annotation.search.entity": "Entity",
  "annotation.search.title": "Annotation search",
  "app.title": "Case Handler",
  "appliedEventsTable.itemName": "events",
  "applyScenarioModal.title": "Apply scenario",
  "applyScenarioModal.warning": "Are you sure you want to apply this scenario variant? This will close the scenario and apply the changes to the commitment.",
  "approve": "Approve",
  "approvePendingCancellation": "Approve cancellation",
  "assignOwnerModal.newOwnerSsnLabel": "New owner",
  "assignOwnerModal.title": "Assign owner",
  "balancePostingsFilter.postingTypes": "Posting types",
  "balancePostingsFilter.resultLimit": "Result limit",
  "balancePostingsFilter.transactionTime": "Transaction date",
  "balancePostingsFilter.valueDate": "Value date",
  "batch.create": "Create batch",
  "batch.fromTemplate": "Create batch from template",
  "batchDetailedView.createdBy": "Created by",
  "batchDetailedView.id": "Batch ID:",
  "batchDetailedView.select": "Selected batch:",
  "batchDetailedView.status": "Batch status:",
  "batchDetailedView.stopBatch": "Stop batch",
  "batchError.100max": "100 max",
  "batchError.10max": "10 max",
  "batchError.custom": "Custom",
  "batchErrors.download": "Download shown batch and error information",
  "batchStatistics.average": "Average",
  "batchStatistics.completeJobWaitDurationStatistics": "Complete wait-time statistics",
  "batchStatistics.completeStatistics": "Complete statistics",
  "batchStatistics.duration": "Duration (ms)",
  "batchStatistics.enumerationDuration": "Enumeration duration (ms)",
  "batchStatistics.execution": "Execution",
  "batchStatistics.jobTimeoutCount": "Job timeout count",
  "batchStatistics.maximum": "Maximum",
  "batchStatistics.minimum": "Minimum",
  "batchStatistics.p50": "P50",
  "batchStatistics.p95": "P95",
  "batchStatistics.p99": "P99",
  "batchStatistics.sampleCount": "Sample count",
  "batchStatistics.title": "Batch statistics",
  "batchStatistics.unavailable": "No statistics are available for this batch.",
  "batchStatistics.waitTime": "WaitTime",
  "batchStatus.activityFrom": "Activity from",
  "batchStatus.activityTo": "Activity to",
  "batchStatus.batchStatusType": "Status",
  "batchStatus.col.created": "Created",
  "batchStatus.col.duration": "Time (min)",
  "batchStatus.col.ended": "Ended",
  "batchStatus.col.entityCount": "Entity count",
  "batchStatus.col.errorCount": "Errors",
  "batchStatus.col.name": "Name",
  "batchStatus.col.progressPct": "Progress %",
  "batchStatus.col.progressVal": "Progress #",
  "batchStatus.col.started": "Started",
  "batchStatus.col.status": "Status",
  "batchStatus.details": "Details",
  "batchStatus.noRestriction": "No restriction",
  "batchStatus.specificationType": "Type",
  "birthOrDeathDate.birthdate": "Birthdate",
  "birthOrDeathDate.deathdate": "Death date",
  "birthdateChangeButton.birthDate": "Birthdate",
  "birthdateChangeButton.birthDateValueDate": "Apply date",
  "birthdateChangeButton.button": "Birthdate",
  "bundlingStops.moneyIn.modalTitle": "Invoice creation stop",
  "cancelInstallmentPlan.description": "This will cancel the instalment plan and resume the original invoices.",
  "cancelInstallmentPlan.title": "Cancel instalment plan",
  "card.field.informationSource": "Information source",
  "ccInput.column.creationStamp": "Creation date",
  "ccInput.column.inputId": "Input ID",
  "ccInput.column.valueDate": "Value date",
  "ccLifeInput.title": "Historical inputs from Life",
  "ccStates.column.calcType": "Calculation type",
  "ccStates.column.creationStamp": "Creation date",
  "ccStates.column.inputId": "Input ID",
  "ccStates.column.status": "Status",
  "ccStates.column.valid": "Is valid",
  "ccStates.column.valueDate": "Value date",
  "ccStates.title": "List of CCD runs",
  "ccStatesTable.advancedExcelExport.title": "Inspect CCD output",
  "ccStatesTable.excelExport.title": "Inspect CCD calculations",
  "ccStatesTable.generalConfirmation.title": "Confirm to send the data to pension administration system",
  "ccStatesTable.generalDescription.title": "Are you sure you want to send the yields and postings to the pension administration system?",
  "ccStatesTable.lifeConfirmation.title": "Confirm to send the data to Life",
  "ccStatesTable.lifeDescription.title": "Are you sure you want to send the yields and postings to Life?",
  "ccdCalculation.title": "CCD calculations",
  "ccdFilterForm.inputId": "Input ID",
  "changeCommitmentModalButton.confirm.added": "Added",
  "changeCommitmentModalButton.confirm.body": "Are you sure you want to apply the following changes? This can only be done after the simulation succeeds.",
  "changeCommitmentModalButton.confirm.field": "Field",
  "changeCommitmentModalButton.confirm.noChanges": "No changes",
  "changeCommitmentModalButton.confirm.removed": "Removed",
  "changeCommitmentModalButton.confirm.simulationFailure": "Simulation failed. The following errors must be fixed before applying the command:",
  "changeCommitmentModalButton.confirm.simulationPending": "Simulation in progress.",
  "changeCommitmentModalButton.confirm.simulationSuccess": "Simulation succeeded.",
  "changeCommitmentModalButton.confirm.title": "Confirm change commitment",
  "changeCommitmentModalButton.title": "Change commitment and state",
  "changeContributionData.input.applyDate": "Apply date",
  "changeContributionData.input.billingFrequency": "Billing frequency",
  "changeContributionData.input.paidInArrears": "Paid in arrears",
  "changeContributionData.title": "Contribution data",
  "changeLegalEntityCommand.confirm.body": "Are you sure you want to apply the following changes?",
  "changeLegalEntityCommand.confirm.title": "Confirm change legal entity",
  "changeTemplateSource.input.applyDate": "Apply date",
  "changeTemplateSource.input.templateSourceId": "Template source ID",
  "changeTemplateSourceCommand.title": "Template source",
  "clearStops.description": "The following indicates areas that can or have a flag",
  "clearStops.doNotCatchUp": "Do not catch up",
  "clearStops.employerAgreement.title": "Agreement stops",
  "collCalc.ccCalcType": "Calculation type",
  "collCalc.details":
    "This page displays a set of yields and a set of corresponding returns and postings for the collective pots.\nThese are the result of calculations performed on the collective level, handling collective capital distribution under SPR and FPR, as well as adjustment of benefits in the collective distribution phase.\nThe calculations are based on the input from the pension administration system and asset manager (uploaded here as an Excel file), and the results are sent to the pension administration system.\nSome of the yields are: interest protection and excess, micro biometric protection and excess, surplus and supplement. The order of calculations, frequency and formulas are fully configurable.",
  "collCalc.sheet": "Excel sheet",
  "collectivePots.account": "Account",
  "collectivePots.accountType": "Account type",
  "collectivePots.action.addBalancePosting": "Collective balance posting",
  "collectivePots.action.editBalancePosting": "Edit balance posting",
  "collectivePots.balance": "Balance",
  "collectivePots.balancePostings": "Balance postings",
  "collectivePots.column.balance": "Balance",
  "collectivePots.column.delta": "Delta",
  "collectivePots.column.endDate": "End date",
  "collectivePots.column.startDate": "Start date",
  "collectivePots.description": "Description",
  "collectivePots.draftWorkPads": "Draft WorkPads",
  "collectivePots.netAmount": "Net amount",
  "command.isScenario": "Scenario",
  "commandData.approvedBy": "Approved by",
  "commandData.cancel": "Cancel command",
  "commandData.cancel.body": "Cancelling a command will revert all of its changes. Please make sure that this is exactly what you want before confirming.",
  "commandData.cancel.title": "Are you sure you want to cancel: {title}?",
  "commandData.cancelledApprovedBy": "Cancellation approved by",
  "commandData.cancelledBy": "Cancelled by",
  "commandData.createdBy": "Created by",
  "commandData.description": "A low number = high priority.",
  "commandData.notAllowedToApproveOwnCommands": "You are not allowed to approve your own commands.",
  "commandData.onlyScenarioCommandAllowed": "It is only possible to perform actions on commands created in a scenario.",
  "commandData.priority": "Priority",
  "commandData.reasonForBeingUnapplied": "Reason for being unapplied",
  "commandData.reasonForBeingUnapplied.approvalPending": "Approval pending",
  "commandData.reasonForBeingUnapplied.cancelApprovalPending": "Cancel approval pending",
  "commandData.reasonForBeingUnapplied.futureApplyDate": "Future apply date",
  "commandData.reasonForBeingUnapplied.missingPersons": "Missing persons",
  "commandEventsGraph.tooltip.around": "Around",
  "commandEventsGraph.tooltip.from": "From",
  "commandEventsGraph.tooltip.to": "To",
  "commandExclustionToggle.tooltip": "Include command when applying scenario",
  "commandModalButton.deflateCommitmentVersion": "Deflated simulation",
  "commandModalButton.hoverAlertToSeeErrorDetails": "Hover over the alert to see error details.",
  "commandModalButton.simulate": "Simulate",
  "commandModalButton.unableToEditToDoCriticalError.body": "Please delete and re-create the command.",
  "commandModalButton.unableToEditToDoCriticalError.title": "The portal is unable to support editing due to a critical error.",
  "commandModalButton.viewError.body": "Actions are still available despite the error. Below you can see all of the data available for this command.",
  "commandModalButton.viewError.title": "An unexpected error occurred",
  "commandPalette.group.favourites.add": "Add to favourites",
  "commandPalette.group.favourites.remove": "Remove from favourites",
  "commandPalette.group.favourites.tooltip.hide": "Hide favourites in this group",
  "commandPalette.group.favourites.tooltip.show": "Show favourites in this group",
  "commandPalette.group.unauthorized.tooltip.hide": "Hide unauthorized in this group",
  "commandPalette.group.unauthorized.tooltip.show": "Show unauthorized in this group",
  "commandPalette.group.warnings.tooltip.hide": "Hide warnings in this group",
  "commandPalette.group.warnings.tooltip.show": "Show warnings in this group",
  "commandPalette.placeholder": "Start typing...",
  "commandTable.column.appliedStatus": "Applied",
  "commandTable.column.applyDate": "Apply date",
  "commandTable.column.approvedBy": "Approved by",
  "commandTable.column.cancelApprovedBy": "Cancel approved by",
  "commandTable.column.cancelledBy": "Cancelled by",
  "commandTable.column.cancelledStatus": "Cancelled",
  "commandTable.column.cancelledTime": "Cancellation time",
  "commandTable.column.commandTemplateId": "Step",
  "commandTable.column.createdBy": "Created by",
  "commandTable.column.createdTime": "Created time",
  "commandTable.column.expectedApplyDate": "Expected apply date",
  "commandTable.column.information": "Information",
  "commandTable.column.rolledBackStatus": "Rolled back",
  "commandTable.column.status": "Status",
  "commandTable.column.unappliedCommand": "Unapplied command",
  "commandTable.title": "Events",
  "commitment.dateSelector.label": "View commitment at",
  "commitment.layout.navigation.covers": "Covers",
  "commitment.layout.navigation.events": "Events",
  "commitment.layout.navigation.home": "Home",
  "commitment.layout.navigation.moneyInInvoices": "Invoices",
  "commitment.layout.navigation.paymentReceiver": "Payment receiver",
  "commitment.layout.navigation.paymentsIn": "Payments in",
  "commitment.layout.navigation.paymentsOut": "Payments out",
  "commitment.layout.navigation.personInformation": "Person information",
  "commitment.layout.navigation.policy": "Policies",
  "commitment.layout.navigation.portfolio": "Portfolio",
  "commitment.layout.navigation.relatedCommitments": "Related commitments",
  "commitment.layout.navigation.scenarios": "Scenarios",
  "commitment.layout.navigation.workbench": "Details",
  "commitmentOverview.information.retirementCard.retirementDate": "Retirement date",
  "commitmentOverview.information.retirementCard.retirementFraction": "Retirement fraction",
  "commitmentOverview.information.retirementCard.title": "Retirement data",
  "commitmentRegressionSpecification.commitmentRegressionCompareDefinitionTemplateId": "Commitment regression compare definition template ID",
  "commitmentRegressionSpecification.coverRegressionCompareDefinitionTemplateId": "Cover regression compare definition template ID",
  "commitmentRegressionSpecification.fromDate": "From date",
  "commitmentRegressionSpecification.policyRegressionCompareDefinitionTemplateId": "Policy regression compare definition template ID",
  "commitmentScenario.form.newFieldInfo": "The title provided does not exist and will result in a new creation",
  "commitmentScenario.form.scenario": "Scenario",
  "commitmentScenario.form.variant": "Variant",
  "commitmentScenario.modal.add": "Add to scenario: {scenarioTitle}, {variantTitle}",
  "commitmentScenario.modal.addUnknown": "Add to scenario",
  "commitmentScenario.modal.create": "Create/add to scenario",
  "commitmentSource.commitmentTime": "Commitment time {commitmentTime}",
  "commitmentStart.startDate": "Participant since {startDate}",
  "commitmentStatus.status": "Commitment status",
  "company.layout.navigation.agreements": "Agreements",
  "company.layout.navigation.home": "Home",
  "company.layout.navigation.legalentity": "Company information",
  "company.layout.navigation.moneyInInvoices": "Invoices",
  "companyInformationCard.endDate": "End date",
  "companyInformationCard.foundationDate": "Start date",
  "companyInformationCard.name": "Name",
  "companyInformationCard.title": "Company information",
  "companySearchForm.similarName": "Similar name",
  "companySearchResultsCard.column.addresses": "Addresses",
  "companySearchResultsCard.column.externalId": "External ID",
  "companySearchResultsCard.column.internalId": "Internal ID",
  "companySearchResultsCard.column.name": "Name",
  "companySection.endDate": "End date",
  "companySection.externalId": "External ID",
  "companySection.foundationDate": "Start date",
  "companySection.internalId": "Internal ID",
  "component.legalentity": "Legalentity",
  "component.life": "Life",
  "component.moneyin": "Money in",
  "component.moneyout": "Money out",
  "component.unitlink": "UnitLink",
  "contributionData.billingFrequency": "Billing frequency",
  "contributionData.paidInArreas": "Paid in arrears",
  "copyVariantModal.commands": "Commands to copy",
  "copyVariantModal.copyNewVariant": "Make new copy: {variantTitle}",
  "copyVariantModal.copyToVariant": "Copy to: {variantTitle}",
  "copyVariantModal.noCommands": "No commands to copy.",
  "copyVariantModal.selectVariant": "Variant name to copy to",
  "count": "Count: {count}",
  "cover.riskEndDate": "End date",
  "coverColumn.benefitEnd": "Benefit end",
  "coverColumn.benefitParameter": "Benefit basis",
  "coverColumn.billingBalance": "Billing balance",
  "coverColumn.calculatedBenefit": "Benefit",
  "coverColumn.claimBalance": "Claim capital",
  "coverColumn.coInsured": "Coinsured",
  "coverColumn.contribFraction": "Percentage",
  "coverColumn.contribPriority": "Priority",
  "coverColumn.coverKey": "Id",
  "coverColumn.coverProductType": "Cover for",
  "coverColumn.coverStatus": "Status",
  "coverColumn.moneyOutEndDate": "End date",
  "coverColumn.moneyOutType": "Type",
  "coverColumn.originalExternalsecondaryId": "Original owner",
  "coverColumn.premiumAmount": "Premium amount",
  "coverColumn.premiumPct": "Premium pct",
  "coverColumn.productName": "Product name",
  "coverColumn.receiverPerson": "Receiver",
  "coverColumn.relatedToCoverKey": "Related to cover",
  "coverColumn.riskBenefitAmount": "Benefit",
  "coverColumn.riskBenefitPct": "Benefit Pct",
  "coverColumn.riskBenefitTriggers": "Cover for",
  "coverColumn.riskEndDate": "End date",
  "coverColumn.savingsBalance": "Balance",
  "coverColumn.taxCode": "Tax code",
  "coverColumn.unitlinkStatus": "UnitLink status",
  "coverColumn.yearlyPremiumParameter": "Premium basis",
  "coverDetails.activeRecurringMoneyOutVersion": "Active recurring money out",
  "coverDetails.billingFrequency": "Billing frequency",
  "coverDetails.coverKey": "Cover key",
  "coverDetails.coverProductType": "Product type",
  "coverDetails.coverStatus": "Cover status",
  "coverDetails.fromDate": "From",
  "coverDetails.insured": "Insured",
  "coverDetails.moneyInTaxCode": "Money in tax code",
  "coverDetails.originalExternalsecondaryId": "Original external secondary ID",
  "coverDetails.policyKey": "Policy key",
  "coverDetails.premium": "Premium",
  "coverDetails.sortPriority": "Sort priority",
  "coverDetails.tenantSubGroup": "Tenant sub-group",
  "coverDetails.title": "Cover details",
  "coverDetails.unitlinkStatus": "UnitLink status",
  "coverDetails.yearlyPremium": "Yearly premium",
  "coverDetailsModal.title": "Cover Details",
  "coverLayerVersion.benefit": "Benefit",
  "coverLayerVersion.name": "Name",
  "coverLayerVersion.tariffId": "Tariff ID",
  "coverList.activeRiskCovers": "Disbursing risk covers",
  "coverList.activeSavingsCovers": "Disbursing savings covers",
  "coverList.balancePostings": "Balance postings",
  "coverList.riskCoverType": "Risk",
  "coverList.riskCovers": "Risk covers",
  "coverList.savingsCoverType": "Savings",
  "coverList.savingsCoverWithBalance": "Savings covers with balance",
  "coverList.savingsCovers": "Savings covers",
  "coverSimulation.title": "Covers",
  "coversSimulation.aggregated": "Aggregated",
  "coversSimulation.detailedView": "Detailed view",
  "coversTable.column.balance": "Balance",
  "coversTable.column.beneficiaryEndAge": "until {age}",
  "coversTable.column.benefit": "Benefit",
  "coversTable.column.benefitEnd": "Benefit end",
  "coversTable.column.coverKey": "Cover",
  "coversTable.column.coverProductType": "Cover for",
  "coversTable.column.coverStatus": "Status",
  "coversTable.column.coverType": "Type",
  "coversTable.column.insured": "Insured",
  "coversTable.column.lifeInsuranceEvents": "Insurance events",
  "coversTable.column.moneyOutLength": "for {years}",
  "coversTable.column.moneyOutType": "Money out type",
  "coversTable.column.policyKey": "Policy",
  "coversTable.column.riskEndDate": "Risk end",
  "coversTabsCard.allCovers": "All covers",
  "createAgreement.applyDate": "Apply date",
  "createAgreement.commitmentTemplateId": "Commitment template ID",
  "createAgreement.companyId": "Company ID",
  "createAgreement.contributionData": "Contribution data",
  "createAgreement.employerAgreementId": "Employer agreement ID",
  "createAgreement.name": "Name",
  "createAgreement.templateSourceId": "Template source ID",
  "createAgreement.title": "New agreement",
  "createAgreement.toDate": "To date",
  "createCommitmentModalButton.template": "Template",
  "createCommitmentModalButton.title": "New commitment",
  "createCompany.address": "Address",
  "createCompany.addresses": "Addresses",
  "createCompany.button": "New company",
  "createCompany.companyId": "Company ID",
  "createCompany.name": "Name",
  "createInstallmentPlan.installment": "Instalment",
  "createInstallmentPlan.installmentTotal": "Instalment total",
  "createInstallmentPlan.installments": "Instalments",
  "createInstallmentPlan.invoiceTotal": "Invoice total",
  "createInstallmentPlan.invoices": "Invoices",
  "createInstallmentPlan.remainingAmount": "Remaining amount",
  "createInstallmentPlan.title": "Instalment plan",
  "createInstallmentPlanform.creationMethod.byAmount": "Fixed amount",
  "createInstallmentPlanform.creationMethod.byInstallments": "Number of instalments",
  "createInstallmentPlanform.creationMethod.manual": "Manually",
  "createInvoiceElementsInvoice.aggregatedAmount": "Sum",
  "createInvoiceElementsInvoice.negative": "Negative",
  "createInvoiceElementsInvoice.numAmounts": "Number of amounts",
  "createInvoiceElementsInvoice.positive": "Positive",
  "createInvoiceElementsInvoice.title": "Create invoice from invoice elements",
  "createInvoiceElementsInvoice.total": "Total",
  "createLegalEntityModalButton.button": "New person",
  "createLegalEntityModalButton.externalId": "External ID",
  "createLegalEntityModalButton.pseudoExternalId": "Pseudo external ID",
  "createPersonCommandData.birthdate": "Birthdate",
  "createPersonCommandData.firstName": "First name",
  "createPersonCommandData.gender": "Gender",
  "createPersonCommandData.initials": "Initials",
  "createPersonCommandData.lastName": "Last name",
  "createPersonCommandData.nationality": "Nationality",
  "createPolicyModalButton.fromDate": "Start date",
  "createPolicyModalButton.policyTemplateId": "Policy template ID",
  "createPolicyModalButton.title": "New policy",
  "darkModeSwitcher.label": "Theme",
  "deathButton.deathDate": "Death date",
  "deathButton.title": "Death",
  "deathClaims.addDeathClaim": "Death claim",
  "deathClaims.benefit": "Benefit",
  "deathClaims.covers": "Covers",
  "deathClaims.policy": "Policy",
  "deathClaims.receiverName": "Beneficiary",
  "deathClaims.receivers": "Benefit receivers",
  "deathClaims.relationshipType": "Relationship",
  "deathClaims.relationshipType.receiver": "Relationship with deceased",
  "deathClaims.senderName": "Deceased",
  "deathClaimsCard.title": "Survivors pension",
  "declinePendingCancellation": "Delete cancellation request",
  "deleteCommitmentSourceExternalPayloadModalButton.title": "Delete commitment source external payload",
  "deleteScenarioModal.title": "Delete scenario",
  "deleteScenarioModal.warning": "Are you sure you want to delete the scenario?",
  "deleteVariantModal.title": "Delete scenario variant",
  "deleteVariantModal.warning": "Are you sure you want to delete the scenario variant?",
  "disabilityLane.fallbackTitle": "Disability",
  "disablePenaltiesInvoice.field.disableFromDate": "From date",
  "divorceButton.endDate": "Divorce date",
  "divorceButton.title": "Divorce",
  "download.commitmentRegression.title": "Download commitment regression",
  "download.commitmentSource.title": "Download commitment (.json)",
  "download.employerAgreementSource.title": "Download employer agreement (.json)",
  "download.exportCommitmentButton.button": "Commitment source (.xlsm)",
  "download.exportCommitmentButton.title": "Download commitment (.xlsm)",
  "download.exportEmployerAgreement.button": "Employer agreement (.xlsm)",
  "download.exportGlPostingsOriginalButton.title": "Download general ledger postings (original)",
  "download.exportInvoice.button": "Invoice (.xlsm)",
  "download.exportMoneyInButton.title": "Download money in (.xlsm)",
  "download.exportMoneyOutButton.title": "Download money out (.xlsm)",
  "download.exportPersonSourceExcelSheet.button": "Legal entity (.xlsm)",
  "download.exportPortfolioButton.button": "Portfolio (.xlsm)",
  "download.exportReconciliationReportButton.title": "Download reconciliation report",
  "download.legalEntitySource.button": "Legal entity (.json)",
  "draftWorkPad.approve.description": "Are you sure you want to approve the workpad?",
  "draftWorkPad.approve.title": "Approve",
  "draftWorkPad.approved": "Approved",
  "draftWorkPad.creationStamp": "Created",
  "draftWorkPad.creationUserId": "Created by",
  "draftWorkPad.delete.description": "Are you sure you want to delete the workpad?",
  "draftWorkPad.delete.title": "Delete",
  "draftWorkPad.deleted": "Deleted",
  "draftWorkPad.includeDeleted": "Include deleted",
  "draftWorkPad.undelete.description": "Are you sure you want to undo delete the workpad?",
  "draftWorkPad.undelete.title": "Undo delete",
  "editBankAccountModal.title": "Edit bank account",
  "editFundCommandSelectionModal.fraction": "Fraction",
  "editFundCommandSelectionModal.fund": "Fund",
  "editFundCommandSelectionModal.isinKey": "Fund",
  "editPartitionCommandSelectionModal.fraction": "Fraction",
  "editPartitionCommandSelectionModal.partition": "Partition",
  "editPartitionCommandSelectionModal.profileType": "Profile type",
  "editPortfolioModalButton.title": "Advanced portfolio editing",
  "employerAgreement.agreementName": "Agreement name",
  "employerAgreement.companyId": "Company ID",
  "employerAgreement.contribution.billingFrequency": "Billing frequency",
  "employerAgreement.contribution.paidInArreas": "Paid in arrears",
  "employerAgreement.contribution.title": "Contribution",
  "employerAgreement.cover.benefit": "Default benefit",
  "employerAgreement.cover.coverId": "Cover ID",
  "employerAgreement.cover.events": "Events",
  "employerAgreement.cover.maxBenefit": "Max benefit",
  "employerAgreement.cover.minBenefit": "Min benefit",
  "employerAgreement.cover.selected": "Default selected",
  "employerAgreement.cover.type": "Type",
  "employerAgreement.covers.title": "Covers",
  "employerAgreement.employeeAgreementTemplateId": "Template",
  "employerAgreement.employerAgreementId": "Agreement ID",
  "employerAgreement.fromDate": "Creation date",
  "employerAgreement.moneyIn.actionRequired": "Action required",
  "employerAgreement.moneyIn.amount": "Amount",
  "employerAgreement.moneyIn.isPaid": "Paid",
  "employerAgreement.moneyIn.person": "Person",
  "employerAgreement.name": "Agreement name",
  "employerAgreement.period": "Period",
  "employerAgreement.policyDetailsCard.defaultSelected": "Default selected",
  "employerAgreement.policyDetailsCard.template": "Template",
  "employerAgreement.policyDetailsCard.title": "Policy details",
  "employerAgreement.status": "Status",
  "employerAgreement.title": "Employer agreement",
  "employerAgreementsTable.title": "Employer agreements",
  "employment.actions.details": "Details",
  "employment.actions.salaryPeriods": "Salary periods",
  "employment.agreementId": "Agreement",
  "employment.benefitBase": "Calculation basis",
  "employment.billingFrequency": "Billing frequency",
  "employment.command.modal.agreementId": "Agreement ID",
  "employment.command.modal.changeDate": "Change date",
  "employment.command.modal.commitmentId": "Commitment ID",
  "employment.command.modal.companyName": "Company name",
  "employment.command.modal.employmentId": "Employment ID",
  "employment.command.modal.endDate": "End date",
  "employment.details.title": "Employments details",
  "employment.employerId": "Employer ID",
  "employment.employmentEnd": "End date",
  "employment.employmentId": "Employment ID",
  "employment.employmentStart": "Start date",
  "employment.movement.premium": "Premium",
  "employment.movement.salary": "Salary",
  "employment.movement.salaryPartTimePct": "Salary part time pct",
  "employment.movement.salaryPeriodEnd": "Salary period end",
  "employment.movement.salaryPeriodStart": "Salary period start",
  "employment.paidInArrears": "Paid in arrears",
  "employment.partTimePercentage": "Part-time percentage",
  "employment.title": "Employments",
  "employment.yearlyPensionableSalary": "Pensionable salary",
  "employment.yearlySalary": "Annual salary",
  "employmentOverview.billingFrequency": "{frequency} payment",
  "employmentRow.details": "Details",
  "enum.ActionOption.CreateEmployerAgreementPolicySelectionData": "Create policy",
  "enum.ActionOption.DeleteEmployerAgreementPolicySelectionData": "Delete policy",
  "enum.ActionOption.UpdateEmployerAgreementPolicySelectionData": "Update policy",
  "enum.ActionWarningCode.aboveEligibleAge": "Above eligible age",
  "enum.ActionWarningCode.alreadyApplied": "Already applied",
  "enum.ActionWarningCode.expectedCommitmentStatus": "Expected commitment status",
  "enum.ActionWarningCode.expectedDateAfter": "Expected date after",
  "enum.ActionWarningCode.hasActivePartner": "Has active partner",
  "enum.ActionWarningCode.hasField": "Has",
  "enum.ActionWarningCode.missingField": "Missing",
  "enum.ActionWarningCode.noActivePartner": "No active partner",
  "enum.ActionWarningCode.noPartner": "No partner",
  "enum.ActionWarningCode.notScenario": "Not scenario",
  "enum.ActionWarningCode.unexpectedCommitmentStatus": "Unexpected commitment status",
  "enum.ActionWarningCode.unexpectedInvoiceStatus": "Unexpected invoice status",
  "enum.ActionWarningCode.unexpectedPolicyStatus": "Unexpected policy status",
  "enum.CommandTemplateId.AddBalancePostingsCommand": "Add balance postings",
  "enum.CommandTemplateId.DeathClaimOrphanCommand": "Death claim orphan",
  "enum.CommandTemplateId.HandleMoneyInCommand": "Handle money in command",
  "enum.CommandTemplateId.NewPolicyCommand": "New policy",
  "enum.CommandTemplateId.NlValueTransferInCommand": "Value transfer in",
  "enum.CommandTemplateId.NlVoluntaryContributionEndStep": "Voluntary contribution end",
  "enum.CommandTemplateId.NlVoluntaryContributionEndStepV2": "Voluntary contribution end",
  "enum.CommandTemplateId.NlVoluntaryContributionStartStep": "Voluntary contribution start",
  "enum.CommandTemplateId.NlVoluntaryContributionStartStepV2": "Voluntary contribution start",
  "enum.CommandTemplateId.NlVoluntaryContributionUpdateStep": "Voluntary contribution update",
  "enum.CommandTemplateId.RetirementCommand": "Retirement command",
  "enum.ExternalPayloadEvent.ExternalPayloadConversionEvent": "Converted from legacy registration",
  "enum.ExternalPayloadEvent.ExternalPayloadCreatedEvent": "Created",
  "enum.ExternalPayloadEvent.ExternalPayloadManualStatusChangeEvent": "Status changed manually",
  "enum.ExternalPayloadEvent.ExternalPayloadProcessedEvent": "Processed",
  "enum.ExternalPayloadEvent.ExternalPayloadProcessingStartedEvent": "Processing started",
  "enum.ExternalPayloadEvent.ExternalPayloadRegisteredEvent": "Registered",
  "enum.ExternalPayloadEvent.ExternalPayloadRejectedEvent": "Rejected",
  "enum.ExternalPayloadEvent.ExternalPayloadRollbackEvent": "Rolled back",
  "enum.ExternalPayloadEvent.ExternalPayloadSentEvent": "Sent",
  "enum.ExternalPayloadEvent.ExternalPayloadUpdateRejectedEvent": "Update rejected",
  "enum.ExternalPayloadEvent.ExternalPayloadUpdatedEvent": "Updated",
  "enum.Persona.AdvisorAllan": "Advisor Allan",
  "enum.Persona.AgreementAnnie": "Agreement Annie",
  "enum.Persona.CommitmentCamilla": "Commitment Camilla",
  "enum.Persona.DeathDennis": "Death Dennis",
  "enum.Persona.FrontOfficeFrida": "Front Office Frida",
  "enum.Persona.HealthHeather": "Health Heather",
  "enum.Persona.MoneyInMark": "Money In Mark",
  "enum.Persona.MoneyOutMichael": "Money Out Michael",
  "enum.Persona.RetirementRita": "Retirement Rita",
  "enum.Persona.TaskListTeddy": "Task List Teddy",
  "enum.PolicyType.PLACEHOLDER": "",
  "enum.PostingDimensions.dim1": "Dim 1",
  "enum.PostingDimensions.dim2": "Dim 2",
  "enum.PostingDimensions.dim3": "Dim 3",
  "enum.PostingDimensions.dim4": "Dim 4",
  "enum.PostingDimensions.dim5": "Dim 5",
  "enum.PostingDimensions.dim6": "Dim 6",
  "enum.PostingDimensions.dim7": "Dim 7",
  "enum.PostingDimensions.dim8": "Dim 8",
  "enum.PostingDimensions.key1": "Key 1",
  "enum.PostingDimensions.key2": "Key 2",
  "enum.PostingDimensions.key3": "Key 3",
  "enum.PostingDimensions.key4": "Key 4",
  "enum.SearchCategories.agreement": "Agreements",
  "enum.SearchCategories.changes": "Changes",
  "enum.SearchCategories.collectiveCalculations": "Collective calculations",
  "enum.SearchCategories.common": "Common",
  "enum.SearchCategories.company": "Company",
  "enum.SearchCategories.contributionHandling": "Contribution handling",
  "enum.SearchCategories.death": "Death",
  "enum.SearchCategories.disabilityAndSickness": "Disability & sickness",
  "enum.SearchCategories.disbursement": "Disbursement",
  "enum.SearchCategories.divorceSeparation": "Divorce & separation",
  "enum.SearchCategories.download": "Download",
  "enum.SearchCategories.employment": "Employment",
  "enum.SearchCategories.externalPayload": "External payload",
  "enum.SearchCategories.favourites": "Favourites",
  "enum.SearchCategories.health": "Health",
  "enum.SearchCategories.incomingPayment": "Incoming payments",
  "enum.SearchCategories.investmentFundHandling": "Investment fund handling",
  "enum.SearchCategories.invoiceHandling": "Invoice handling",
  "enum.SearchCategories.marriageCohabitantChildren": "Marriage, cohabitant & children",
  "enum.SearchCategories.migration": "Migration",
  "enum.SearchCategories.new": "New",
  "enum.SearchCategories.outgoingPayment": "Outgoing payments",
  "enum.SearchCategories.person": "Person",
  "enum.SearchCategories.policy": "Policies",
  "enum.SearchCategories.portfolio": "Portfolio",
  "enum.SearchCategories.portfolioHandling": "Portfolio handling",
  "enum.SearchCategories.pretend": "Pretend",
  "enum.SearchCategories.retirement": "Retirement",
  "enum.SearchCategories.specialCommands": "Special commands",
  "enum.SearchCategories.stop": "Stop",
  "enum.SearchCategories.tax": "Tax",
  "enum.SearchCategories.tenant": "Fund",
  "enum.SearchCategories.termination": "Termination",
  "enum.SearchCategories.transfers": "Transfers",
  "enum.SearchGroup.command": "Command",
  "enum.SearchGroup.navigation": "Navigation",
  "enum.SearchGroup.recent": "Recent",
  "enum.SearchGroup.settings": "Settings",
  "enum.SearchGroup.tenant": "Fund",
  "enum.ShortEmployerAgreementStatus.active": "A",
  "enum.ShortEmployerAgreementStatus.future": "F",
  "enum.ShortEmployerAgreementStatus.terminated": "T",
  "enum.Step.AddAccessGroupAnnotationStep": "Add access group annotation",
  "enum.Step.AddBalancePostingsStep": "Manually updated capital",
  "enum.Step.AddFundMergeStep": "Add fund merge",
  "enum.Step.AddInsuredStep": "Participant info added",
  "enum.Step.AddMigrationStepV1": "Migration",
  "enum.Step.AddMigrationStepV3": "Migration",
  "enum.Step.AddMigrationStepV4": "Migration",
  "enum.Step.AddPayableStopStep": "Add payable stop",
  "enum.Step.AddPaymentChannelStep": "Add payment channel",
  "enum.Step.AddRelatedPersonStep": "Related Person added",
  "enum.Step.AddUpaFileStep": "Add UPA file",
  "enum.Step.AddressChangeStep": "Update address",
  "enum.Step.AdvanceMonthStep": "Advance month",
  "enum.Step.AmendAccessGroupAnnotationStep": "Amend access group annotation",
  "enum.Step.AmendCoversSelectionStep": "Amend cover",
  "enum.Step.AmendEmployerAgreementCoversStep": "Amend covers",
  "enum.Step.AmendEmployerAgreementPoliciesStep": "Amend policies",
  "enum.Step.BirthDateChangeStep": "Birth date change",
  "enum.Step.ChangeAgreementStep": "Change agreement",
  "enum.Step.ChangeCommitmentAndStateStep": "Manually updated",
  "enum.Step.ChangeCommitmentTemplateSourceStep": "Change commitment template source",
  "enum.Step.ChangeContributionDataStep": "Change contribution data",
  "enum.Step.ChangeDataChannelStep": "Change data channel",
  "enum.Step.ChangeNameStep": "Change name",
  "enum.Step.ChangePartnerIdStep": "Change partner ID",
  "enum.Step.ChangeRiskProfileStep": "Change risk profile",
  "enum.Step.ChangeTemplateSourceStep": "Change template source",
  "enum.Step.CloseCommitmentStep": "Participation closed",
  "enum.Step.CloseSubPortfolio": "Close sub portfolio",
  "enum.Step.CloseSubPortfolioTrade": "Close sub portfolio trade",
  "enum.Step.CreateAgreementStep": "Create agreement",
  "enum.Step.CreateCompanyStep": "Create company",
  "enum.Step.CreateEmployment": "New employment added",
  "enum.Step.CreateInvoiceStep": "Create invoice",
  "enum.Step.CreatePaymentReceiverStep": "Create payment receiver",
  "enum.Step.CreatePersonMigrationV3Step": "New person migrated",
  "enum.Step.CreatePersonStep": "Create person",
  "enum.Step.DeletePayableStopStep": "Delete payable stop",
  "enum.Step.DeletePaymentChannelStep": "Delete payment channel",
  "enum.Step.DisablePenaltiesInvoiceStep": "Disable penalties on invoice",
  "enum.Step.EditPayableStopStep": "Edit payable stop",
  "enum.Step.EditPaymentChannelStep": "Edit payment channel",
  "enum.Step.EndPartnerMigrationV3Step": "End partner migration",
  "enum.Step.EndPartnerMigrationV4Step": "End partner migration",
  "enum.Step.EndPartnershipStep": "End partnership",
  "enum.Step.ExternalIdChangeStep": "External ID change",
  "enum.Step.GenderChangeStep": "Change gender",
  "enum.Step.HandleAnnuityMoneyOutStep": "Monthly annuity handled",
  "enum.Step.HandleCoverEndStep": "Cover ended",
  "enum.Step.HandleDeathBeneficiaryStep": "Death claim added",
  "enum.Step.HandleLumpSumMoneyOut": "Handle lump sum money out",
  "enum.Step.HandlePolicyPostponeStep": "Postpone retirement handled",
  "enum.Step.HandleTemplateChangeStep": "Handle template change",
  "enum.Step.HandleTriggerMessageStep": "Handle trigger message",
  "enum.Step.HandleUnitlinkClosedPortfolioStep": "Handle UnitLink closed portfolio",
  "enum.Step.HandleWopMoneyInStep": "Handle Wop Money in",
  "enum.Step.HandleYearStartStep": "Year start reset",
  "enum.Step.InsuredPersonDeathUpdateBalanceStep": "Death update balance",
  "enum.Step.InsuredPersonStateParentStep": "Insured person state parent",
  "enum.Step.InternalCoverTransferStep": "Internal cover transfer",
  "enum.Step.InternalTransferStep": "Internal transfer completed",
  "enum.Step.InvestmentSpec": "Investment specification",
  "enum.Step.InvestmentTrade": "Investment trade",
  "enum.Step.MoveSubPortfolio": "Move sub portfolio",
  "enum.Step.NameChangeStep": "Change name",
  "enum.Step.NewSubPortfolios": "Sub-portfolios created",
  "enum.Step.NoChanges": "Employment unchanged",
  "enum.Step.NoUpdatesToInsuredStep": "No updates to insured",
  "enum.Step.NoUpdatesToRelatedPersonStep": "No updates to related person",
  "enum.Step.PartnerBirthdateChangeStep": "Partner birthdate change",
  "enum.Step.PartnerDeceasedStep": "Partner deceased",
  "enum.Step.PartnerNameChangeStep": "Partner name change",
  "enum.Step.PersonDeceasedStep": "Person deceased",
  "enum.Step.PortfolioCorrection": "Portfolio correction",
  "enum.Step.PortfolioDividend": "Portfolio dividend",
  "enum.Step.PortfolioFundCost": "Fund cost",
  "enum.Step.PortfolioFundMerge": "Portfolio fund merge",
  "enum.Step.PortfolioKickback": "Portfolio kickback",
  "enum.Step.PretendDeathStep": "Pretend death",
  "enum.Step.Rebalance": "Rebalance",
  "enum.Step.ReconcileInvoiceStep": "Reconcile invoice",
  "enum.Step.RelatedPersonDeathStep": "Related person death",
  "enum.Step.RelatedPersonStateParentStep": "Related person state parent",
  "enum.Step.RelocationStep": "Relocation",
  "enum.Step.RemoveAccessGroupAnnotationStep": "Remove access group annotation",
  "enum.Step.ResumeInvoiceStep": "Resume invoice",
  "enum.Step.RetirementStep": "Retired",
  "enum.Step.RollbackStep": "Recalculation",
  "enum.Step.SendBillingStep": "Send billing",
  "enum.Step.SendReminderStep": "Send reminder",
  "enum.Step.SetDefaultPaymentChannelStep": "Set default payment channel",
  "enum.Step.SetPartnerStep": "Set partner",
  "enum.Step.SetPersonStateStep": "Set person state",
  "enum.Step.SetPortfolioOwner": "Set portfolio owner",
  "enum.Step.StartEmployerRegistrationStep": "Start employer registration",
  "enum.Step.StartPartnerMigrationV3Step": "Start partner migration",
  "enum.Step.StartPartnerMigrationV4Step": "Start partner migration",
  "enum.Step.SwitchSubPortfolioGroupCommandStep": "Switch portfolio for customer policy",
  "enum.Step.SwitchTrade": "Switch trade",
  "enum.Step.TradeExecution": "Trade execution",
  "enum.Step.UlBalance": "Unitlink balance",
  "enum.Step.UnitlinkConversion": "Unitlink conversion",
  "enum.Step.UpdateCommunicationPreferenceStep": "Update communication preference",
  "enum.Step.UpdateEmployment": "Employment updated",
  "enum.Step.UpdateEmploymentFromDate": "Update employment from date",
  "enum.Step.UpdateNameStepApply": "Update name step apply",
  "enum.Step.UpdatePartnershipStep": "Update partnership",
  "enum.Step.UpdatePointOfContactStep": "Change points of contact",
  "enum.TradeCycleEvent.AcknowledgeTradeOrderEvent": "Trade order acknowledged",
  "enum.TradeCycleEvent.AggregatedTradeCycleEvent": "Aggregated trade cycle",
  "enum.TradeCycleEvent.ClosedTradeCycleEvent": "Trade cycle closed",
  "enum.TradeCycleEvent.CompletedTradeCycleEvent": "Trade cycle completed",
  "enum.TradeCycleEvent.InvestedTradeCycleEvent": "Trade cycle invested",
  "enum.TradeCycleEvent.ManualFixupTradeCycleEvent": "Manual fix-up",
  "enum.TradeCycleEvent.SentTradeOrderEvent": "Trade order sent",
  "enum.TradeCycleEvent.StartTradeCycleEvent": "Trade cycle started",
  "enum.TradeCycleEvent.TradePricesReceivedEvent": "Received trade prices",
  "enum.TradeCycleStatus.aggregated": "Aggregated",
  "enum.TradeCycleStatus.closed": "Closed",
  "enum.TradeCycleStatus.completed": "Completed",
  "enum.TradeCycleStatus.completelyAcknowledged": "Completely acknowledged",
  "enum.TradeCycleStatus.completelySent": "Completely sent",
  "enum.TradeCycleStatus.invested": "Invested",
  "enum.TradeCycleStatus.partlyAcknowledged": "Partly acknowledged",
  "enum.TradeCycleStatus.partlySent": "Trade order sent",
  "enum.TradeCycleStatus.somePricesReceived": "Some prices received",
  "enum.TradeCycleStatus.started": "Started",
  "enum.scenarioHistoryState.applied": "Applied",
  "enum.scenarioHistoryState.cancelled": "Cancelled",
  "enum.scenarioHistoryState.closed": "Closed",
  "enum.scenarioHistoryState.open": "Open",
  "enum.searchEntity.company": "company",
  "enum.searchEntity.invoice": "invoice",
  "enum.searchEntity.person": "person",
  "error.applyStop": "Apply stop: Commands can be added but nothing can be applied. If you try to do a catch-up, you will get an error.",
  "error.applyStopSimulationNotPossible": "Apply stop: Simulation is not possible",
  "error.communicationStop": "Communication stop: The event engine does not use this flag, but specific event sources and steps might assign a meaning to this flag.",
  "error.errorApplyStop": "Error apply stop: Applying commands stopped due to errors: {reason}",
  "error.fullStop": "Full stop: No commands can be added and nothing can be applied.",
  "error.validation.message": "Validation error",
  "event.helpText.viewAdvancedEventView": "Open advanced event view",
  "event.helpText.viewFilter": "View filter",
  "event.helpText.viewGraphEventList": "Switch to graph view",
  "event.helpText.viewHistory": "View stop history",
  "event.helpText.viewPostings": "View postings",
  "event.helpText.viewTableEventList": "Switch to table view",
  "eventBalancePostingsTable.title": "Event balance postings",
  "eventList.columns.after": "After",
  "eventList.columns.applyDate": "Applied",
  "eventList.columns.before": "Before",
  "eventList.columns.expectedApplyDate": "Expected apply date",
  "eventList.columns.step": "Step",
  "eventList.columns.unappliedCommand": "Unapplied command",
  "eventList.columns.unappliedCommand.noCommandType": "No commandType was found",
  "eventList.columns.valueDate": "Creation date",
  "eventList.filter.autoCommands": "AutoCommands",
  "eventList.filter.events": "Events",
  "eventList.filter.scenarioCommands": "Scenario commands",
  "eventList.filter.showRecalculation": "Show recalculation",
  "eventList.title": "Events",
  "eventOpenPostPostingsTable.title": "Open postings",
  "eventSelectionPostings.title": "Posting for selected events",
  "eventsModal.title": "Events",
  "exportGlPostingsOriginalForm.component": "Component",
  "exportGlPostingsOriginalForm.seqNos": "Sequence numbers",
  "exportReconciliationReportForm.component": "Component",
  "exportReconciliationReportForm.noSpecIdsWarning": "No spec IDs found for the selected component",
  "exportReconciliationReportForm.specId": "Spec ID",
  "exportSimulationModal.action": "Export collective calculation simulation",
  "exportSimulationModal.title": "Export simulation",
  "externalIdChange.company.title": "Change company's external ID",
  "externalIdChange.newExternalId": "New external ID",
  "externalIdChange.person.title": "Change person's external ID",
  "externalIdChange.pseudoExternalId": "Pseudo-external ID",
  "externalPayload.batchId": "Batch ID",
  "externalPayload.batchesTab": "Batches",
  "externalPayload.blobName": "Blob name",
  "externalPayload.count": "External payloads ({count})",
  "externalPayload.creationTime": "Creation time",
  "externalPayload.events.batch": "Batch",
  "externalPayload.events.deleted": "Deleted",
  "externalPayload.events.details": "Details",
  "externalPayload.events.newLatestEventId": "New latest event ID",
  "externalPayload.events.originalStatus": "Original status",
  "externalPayload.events.processId": "Process ID",
  "externalPayload.events.reason": "Reason",
  "externalPayload.events.stamp": "Time",
  "externalPayload.events.type": "Event",
  "externalPayload.externalPayloadsTab": "External payloads",
  "externalPayload.externalReference": "External reference",
  "externalPayload.integrationName": "Integration",
  "externalPayload.key": "Payload key",
  "externalPayload.missingPayloadLookupData": "Tenant ID and batch ID are required to find external payloads.",
  "externalPayload.noPayloadForBatch": "No external payload was found for this batch.",
  "externalPayload.registrationDate": "Registration date",
  "externalPayload.registrationFromDate": "Registration from",
  "externalPayload.registrationToDate": "Registration to",
  "externalPayload.showEvents": "Show events history",
  "externalPayload.showExternalPayloads": "Show external payloads",
  "externalPayload.status": "Status",
  "externalPayload.tenantId": "Tenant ID",
  "externalPayload.type": "Payload type",
  "externalPayload.user": "User",
  "form.missingFrame.warning": "Unable to get any or show validation. Use with caution",
  "frontpage.personaSwitcher": "Persona selection",
  "frontpage.recentLinks": "Last looked up",
  "frontpage.welcome": "Welcome",
  "frontpage.welcomeMessage": "Hello {name}",
  "fund.actions.addDividend": "Dividend",
  "fund.actions.addFundMerge": "Investment fund merge",
  "fund.actions.createFund": "New investment fund",
  "fund.actions.update": "Update investment fund",
  "fund.dividends": "Dividends",
  "fund.graph.view": "Graph view",
  "fund.graph.view.daily": "Daily",
  "fund.graph.view.monthly": "Monthly",
  "fund.graph.view.yearly": "Yearly",
  "fund.prices": "Fund prices",
  "fund.prognosisAssetFractions": "Wanted asset fractions",
  "fund.table.view": "Table view",
  "fundCommandSelectionTable.addFund": "Add fund",
  "fundCommandSelectionTable.currentCashValueFraction": "Current savings fraction",
  "fundCommandSelectionTable.currentFraction": "Current fraction",
  "fundCommandSelectionTable.fund": "Fund",
  "fundCommandSelectionTable.fundsTableTitle": "Funds for {profileType}",
  "fundCorrection.amount": "Amount",
  "fundCorrection.isinKey": "Fund",
  "fundCorrection.partitionKey": "Investment profile",
  "fundCorrection.units": "Units",
  "fundPage.commandsEmpty.informationMessage": "No fund found for {isinKey} in tenant {tenantId}",
  "funds.fundDividend.amount": "Amount per unit",
  "funds.fundDividend.date": "Effective date",
  "funds.fundDividends.element": "Dividend",
  "funds.fundItem": "Fund item",
  "funds.fundItem.assetManagerId": "Asset manager ID",
  "funds.fundItem.createdBy": "Created by",
  "funds.fundItem.creationStamp": "Creation stamp",
  "funds.fundItem.fundDividends": "Fund dividends",
  "funds.fundItem.fundMerge.date": "Date",
  "funds.fundItem.fundMerge.destinationIsinKey": "Destination ISIN key",
  "funds.fundItem.fundRiskLevel": "Fund risk level",
  "funds.fundItem.internalCost": "APR",
  "funds.fundItem.internalId": "Internal ID",
  "funds.fundItem.isinKey": "ISIN key",
  "funds.fundItem.name": "Name",
  "funds.fundItem.prognosisAssetFractions": "Prognosis asset fractions",
  "funds.fundItem.shortName": "Shortname",
  "funds.fundItem.usageEnded": "Usage ended",
  "funds.fundItems.title": "Funds",
  "funds.fundPrices.buyPrice": "Buy price",
  "funds.fundPrices.date": "Date",
  "funds.fundPrices.sellPrice": "Sell price",
  "funds.fundPrices.valuePrice": "Price",
  "funds.prognosisAssetFraction.element": "Prognosis asset fraction",
  "funds.prognosisAssetFraction.fraction": "Fraction",
  "funds.prognosisAssetFraction.prognosisAssetClass": "Prognosis asset class",
  "genderChange.button": "Gender change",
  "genderChange.field.changeDate": "Change date",
  "genderChange.field.gender": "Gender",
  "groupedPayment.monthlyAmount": "Monthly amount",
  "groupedPayment.periodEnd": "Period end",
  "groupedPayment.periodStart": "Period start",
  "hasField.commitmentVersion": "commitment version",
  "hasField.nonNegativeInvoiceAmount": "an invoice amount that is not negative",
  "idToLegalEntity.accessDenied": "You do not have access to view this entity.",
  "installmentCreation.dueDate": "Due date",
  "installmentCreation.numberOfInstallments": "Number of instalments",
  "installments.amount": "Amount",
  "installments.dueDate": "Due date",
  "installments.outstandingAmount": "Outstanding amount",
  "installments.title": "Instalments",
  "internalIdInput.externalCompany": "Company",
  "internalIdInput.externalPerson": "SSN",
  "internalIdInput.identifierType": "ID type",
  "internalIdInput.internal": "Internal ID",
  "internalIdInput.pseudoExternalPerson": "Pseudo SSN",
  "investmentSpecModalButton.title": "Investment specification",
  "invoiceOperation.dueDate": "Due date",
  "invoiceOperation.internalDueDate": "Internal due date",
  "invoiceOperation.operationDate": "Operation date",
  "invoiceOperation.operationId": "Operation ID",
  "invoiceOperation.status": "Status",
  "invoiceOperation.status.executed": "Executed",
  "invoiceOperation.status.future": "Future",
  "invoiceOperation.terminateAction": "Terminate action",
  "invoiceOperation.title": "Operations",
  "invoicePaymentVersions.addedDate": "Added date",
  "invoicePaymentVersions.amount": "Amount",
  "invoicePaymentVersions.itemName": "payments",
  "invoicePaymentVersions.paymentDate": "Payment date",
  "invoicePaymentVersions.title": "Payments",
  "invoicePaymentVersions.writeOffCategory": "Write off category",
  "invoicePaymentVersions.writeOffType": "Write off type",
  "invoiceSpecification.button": "Specification",
  "invoiceSpecification.title": "Specification",
  "invoiceTable.amount": "Amount",
  "invoiceTable.fromDate": "From date",
  "invoiceTable.invoiceDate": "Invoice date",
  "invoiceTable.invoiceId": "Invoice ID",
  "invoiceTable.invoiceStatus": "Invoice status",
  "invoiceTable.requestedDueDate": "Due date",
  "invoiceTable.toDate": "To date",
  "invoiceVersion.billingMethodType": "Billing method type",
  "invoiceVersion.dueDate": "Payment due date",
  "invoiceVersion.installment": "Instalment plan",
  "invoiceVersion.internalDueDate": "Internal due date",
  "invoiceVersion.invoice": "Invoice",
  "invoiceVersion.invoiceStatus": "Status",
  "invoiceVersion.invoiceStrategyId": "Strategy ID",
  "invoiceVersion.netAmount": "Net amount",
  "invoiceVersion.partiallyPaidAmount": "Paid amount",
  "invoiceVersion.payerId": "Payer ID",
  "invoiceVersion.suspensionDate": "Suspension date",
  "invoiceVersion.suspensionReason": "Suspension reason",
  "invoiceVersion.totalAmount": "Total amount",
  "invoicesPage.title": "Invoices",
  "layout.navigation.annotation": "Annotation",
  "layout.navigation.collCalc": "Collective calculations",
  "layout.navigation.funds": "Funds",
  "layout.navigation.home": "Home",
  "layout.navigation.moneyInMatch": "Match",
  "layout.navigation.moneyInPayments": "Payments",
  "layout.navigation.search": "Search",
  "layout.navigation.tradeCycles": "Trade cycles",
  "legalentity.rollbackEventModalButton.title": "Recalculate legal entity events",
  "life.enum.CoverType.PLACEHOLDER": "",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToAccountSpecification": "Account",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToLegalEntitySpecification": "Legal Entity",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToSenderSpecification": "Sender",
  "life.rollbackEventModalButton.title": "Recalculate commitment events",
  "limitAlert.moreResults": "There are more results available. Adjust/add more filters.",
  "lookupForm.info.id": "If an external ID is used for the search, do not use any special characters (-, /, _, etc.).",
  "lookupForm.input.externalOrInternalId": "Internal / external ID",
  "lookupForm.input.internalId": "Internal ID",
  "lumpsumPayments.amount": "Amount",
  "lumpsumPayments.heading": "Lump sum payments",
  "lumpsumPayments.key": "Cover key",
  "lumpsumPayments.name": "Cover Name",
  "lumpsumPayments.paymentDate": "Date",
  "lumpsumPayments.type": "Type",
  "main.tenantNotFound": "Selected tenant could not be found",
  "markUnrelatedModal.input.unrelatedPaymentType": "Unrelated payment type",
  "markUnrelatedModal.title": "Mark unrelated",
  "memberInfo.married": "Married",
  "missingField.birthDate": "birth date",
  "moneyIn.amount": "Amount",
  "moneyIn.billingAmount": "Assumed premium",
  "moneyIn.details.modalTitle": "Money In Postings",
  "moneyIn.employer": "Employer",
  "moneyIn.match.action.assignOwner": "Assign owner",
  "moneyIn.match.action.creditPaymentInvoice": "Credit payment invoice",
  "moneyIn.match.action.markUnrelated": "Mark as unrelated",
  "moneyIn.match.action.match": "Match",
  "moneyIn.match.action.returnPayment": "Return payment",
  "moneyIn.match.amount": "Amount",
  "moneyIn.match.attachInvoicePayment.accountId": "Account ID",
  "moneyIn.match.attachInvoicePayment.receiverId": "Receiver ID",
  "moneyIn.match.attachInvoicePayment.returnTo": "Return to",
  "moneyIn.match.date": "Date",
  "moneyIn.match.debt": "Debt",
  "moneyIn.match.debtType": "Type",
  "moneyIn.match.debtType.installmentPlan": "Instalment plan",
  "moneyIn.match.debtType.invoice": "Invoice",
  "moneyIn.match.filter.amountFrom": "Min amount",
  "moneyIn.match.filter.amountTo": "Max amount",
  "moneyIn.match.filter.includeClosed": "Include closed",
  "moneyIn.match.filter.isSuspended": "Suspended",
  "moneyIn.match.filter.originalPayment": "Original payment",
  "moneyIn.match.filter.resultLimit": "Result limit",
  "moneyIn.match.filter.resultLimit.option.noLimit": "No limit",
  "moneyIn.match.invoiceContainedInInstallmentPlan": "Invoice is part of instalment plan {installmentPlanInfo}. If it's not visible, try adjusting the filters.",
  "moneyIn.match.invoicesTab": "Invoices",
  "moneyIn.match.netAmount": "Net amount",
  "moneyIn.match.outstandingAmount": "Remaining amount",
  "moneyIn.match.payerId": "Payer ID",
  "moneyIn.match.paymentType": "Type",
  "moneyIn.match.reference": "Reference",
  "moneyIn.match.status": "Current status",
  "moneyIn.match.suspendedAt": "Suspended at",
  "moneyIn.match.title": "Payments",
  "moneyIn.match.totalAmount": "Total amount",
  "moneyIn.payments.amount": "Amount",
  "moneyIn.payments.entryRef": "Entry ref",
  "moneyIn.payments.filter.originalPayment": "Original payment",
  "moneyIn.payments.ownerId": "Owner ID",
  "moneyIn.payments.paymentDate": "Payment date",
  "moneyIn.payments.paymentStatus": "Status",
  "moneyIn.payments.paymentType": "Type",
  "moneyIn.payments.reconcileInfo": "Reconcile info",
  "moneyIn.payments.title": "Payments",
  "moneyIn.period": "Period",
  "moneyIn.title": "Money in",
  "moneyIn.type": "Type",
  "moneyInBundlingStopForm.bundlingStop": "Stop invoice creation",
  "moneyOut.amount": "Amount",
  "moneyOut.cover": "Cover",
  "moneyOut.details.modalTitle": "Money Out Postings",
  "moneyOut.enum.PaymentChannel.IbanPaymentChannel": "IBAN",
  "moneyOut.enum.PaymentChannel.SwiftPaymentChannel": "SWIFT",
  "moneyOut.period": "Period",
  "moneyOut.receiver": "Receiver",
  "moneyOut.receiverPal": "Tax authority",
  "moneyOut.stop.description": "Description: ",
  "moneyOut.stop.paymentType": "Type: {paymentType}",
  "moneyOut.title": "Money out",
  "moneyOut.type": "Type",
  "moneyOutLatestHistory.title": "The 10 most recent payouts",
  "nameChangeButton.button": "Name",
  "nameChangeButton.field.changeDate": "Date",
  "nameChangeButton.firstName": "First name",
  "nameChangeButton.lastName": "Last name",
  "navigation.collCalc": "Collective calculation",
  "navigation.datamart": "Datamart",
  "navigation.datamart2": "Datamart 2",
  "navigation.legalentity": "Legal entity",
  "navigation.legalentitydatareplicator": "Legal Entity Data Replicator",
  "navigation.life": "Life",
  "navigation.lifedatareplicator": "Life Data Replicator",
  "navigation.moneyin": "Money in",
  "navigation.moneyout": "Money out",
  "navigation.unitlink": "UnitLink",
  "navigation.unitlinkdatareplicator": "UnitLink Data Replicator",
  "newCcdCalculation.title": "New CCD calculation",
  "noRecordsFound": "No records found",
  "openPostPosting.column.amount": "Amount",
  "openPostPosting.column.dim1": "Payer",
  "openPostPosting.column.paymentDate": "Payment date",
  "openPostPosting.column.reconcileNote": "Bank ref.",
  "openPostPosting.column.valueDate": "Creation date",
  "openPostPostingDetails.employerId": "Employer ID",
  "openPostPostingDetails.valueDate": "Value date",
  "openPostPostingVersion.accountType": "Account type",
  "openPostPostingVersion.amount": "Amount",
  "openPostPostingVersion.fromDueDate": "Due date (from)",
  "openPostPostingVersion.limitedResultsHint": "Only {count} results are being shown.",
  "openPostPostingVersion.matchable": "Matchable",
  "openPostPostingVersion.postingType": "Posting type",
  "openPostPostingVersion.title": "Open post postings",
  "openPostPostingVersion.toDueDate": "Due date (to)",
  "openPostPostingVersion.unmatchedAmount": "Unmatched amount",
  "openPostPostingVersion.valueDate": "Value date",
  "openPostPostingVersion.voucher": "Voucher",
  "openPostPostings.matchable": "Matchable",
  "openPostPostings.postingType": "Type",
  "openPostPostings.unmatchedAmount": "Amount",
  "openPostPostings.valueDate": "Date",
  "option.insufficientAccessRights": "Insufficient access rights",
  "pageNotFound.backToHomepage": "Back to homepage",
  "pageNotFound.text": "The page you are looking for can not be found",
  "pageNotFound.title": "Not Found",
  "pages.commitment.tabs.policies": "policies",
  "pages.commitment.tabs.policyEmptyReason": "Commitment is {status}",
  "pages.landing.description": "Select a component to get started",
  "paidUpPeriod.end": "End date",
  "paidUpPeriod.start": "Start date",
  "paidUpPeriod.title": "Paid Up",
  "participantSection.ssn": "SSN",
  "partitionCommandSelectionTable.addNewPartition": "New partition",
  "partitionCommandSelectionTable.currentCashValueFraction": "Current savings fraction",
  "partitionCommandSelectionTable.currentFraction": "Current payment fraction",
  "partitionCommandSelectionTable.partitionsTableTitle": "Aggregated partitions",
  "partitionCommandSelectionTable.profileType": "Profile type",
  "partnerCard.birthdate": "Birthdate",
  "partnerCard.deathDate": "Death date",
  "partnerCard.endDate": "Relationship end",
  "partnerCard.partnerName": "Partner name",
  "partnerCard.startDate": "Relationship start",
  "partnership.endDate": "Partnership end",
  "partnership.partnerBirthdate": "Partner birthdate",
  "partnership.partnerDeathDate": "Partner death date",
  "partnership.partnerGender": "Partner gender",
  "partnership.partnerName.firstName": "First name",
  "partnership.partnerName.initials": "Initials",
  "partnership.partnerName.lastName": "Last name",
  "partnership.partnerPersonId": "Partner ID",
  "partnership.partnershipId": "Partnership ID",
  "partnership.partnershipType": "Partnership type",
  "partnership.startDate": "Partnership start",
  "partnershipHistoryModal.alert.noPreviousPartners": "No previous partners to show",
  "partnershipHistoryModal.birthDate": "Birthdate",
  "partnershipHistoryModal.deathDate": "Death date",
  "partnershipHistoryModal.endDate": "Relationship end",
  "partnershipHistoryModal.partnershipType": "Partnership type",
  "partnershipHistoryModal.personId": "SSN",
  "partnershipHistoryModal.startDate": "Relationship start",
  "partnershipHistoryModal.title": "Relationship history",
  "pauseInvoice.field.reason": "Reason",
  "pauseInvoice.field.transitionTo": "Transition to",
  "payableStops.moneyOut.history.action": "History",
  "payableStops.moneyOut.history.endDate": "End date",
  "payableStops.moneyOut.history.startDate": "Start date",
  "payableStops.moneyOut.history.title": "Payable-stop history",
  "payableStops.moneyOut.modalTitle": "Payment stops",
  "payableStops.moneyOut.paymentType": "Payment type",
  "payableStops.moneyOut.stopReason": "Stop reason",
  "payableStops.moneyOut.table": "Payment stops",
  "paymentChannel.accountNumber": "Account number",
  "paymentChannel.accountType": "Account",
  "paymentChannel.bankAccount": "Account details",
  "paymentChannel.bic": "BIC",
  "paymentChannel.criteria": "Criteria",
  "paymentChannel.currency": "Currency",
  "paymentChannel.default": "Default",
  "paymentChannel.ibanNumber": "IBAN number",
  "paymentChannelCriterion.lifeInsuranceEvent": "Life insurance event",
  "paymentChannelCriterion.outgoingPaymentType": "Outgoing payment type",
  "paymentChannels.history.action": "History",
  "paymentChannels.history.endDate": "End date",
  "paymentChannels.history.startDate": "Start date",
  "paymentChannels.history.title": "Payment channel history",
  "paymentChannels.title": "Payment channels",
  "paymentInfoDetails.amount": "Amount",
  "paymentInfoDetails.entryRef": "Entry ref",
  "paymentInfoDetails.ownerId": "Owner ID",
  "paymentInfoDetails.paymentDate": "Payment date",
  "paymentInfoDetails.reconcileInfo": "Reconcile info",
  "paymentInfoDetails.splitFromPaymentId": "Split from payment",
  "paymentInfoDetails.status": "Status",
  "paymentInfoDetails.title": "Payment",
  "paymentInfoDetails.type": "Type",
  "paymentSimulation.detailedView": "Detailed view",
  "paymentSimulation.groupedMonthlyAndSinglePaymentsView": "Monthly periods and single payments view",
  "paymentSimulation.title": "Payments",
  "paymentSimulation.warning": "Unsupported payment types found, please use detailed view: {unsupportedPaymentTypes}",
  "paymentsIn.graph.title": "Payments for the last {year} years",
  "paymentsIn.notFound": "No payment information was found for this participant.",
  "paymentsIn.table.title": "Payments",
  "paymentsIn.timeline.all": "All",
  "paymentsIn.timeline.filtered": "Filtered",
  "paymentsOut.graph.title": "Payments for the last {year} years",
  "paymentsOut.notFound": "No payment information was found for this participant.",
  "paymentsOut.table.title": "Payments",
  "paymentsOut.timeline.all": "All",
  "paymentsOut.timeline.filtered": "Filtered",
  "personEntityCard.birthdate": "Birthdate",
  "personEntityCard.deathDate": "Death date",
  "personEntityCard.initials": "Initials",
  "personEntityCard.nationality": "Nationality",
  "personEntityPage.workflowActions": "Workflow actions",
  "personSection.stops": "Stops",
  "personStateDataDetails.birthDate": "Birth date",
  "personStateDataDetails.deathDate": "Death date",
  "personStateDataDetails.personId": "Person ID",
  "pointOfContact.button": "Points of contact",
  "pointOfContact.enum.type.Email": "Email",
  "pointOfContact.enum.type.EmailVersion": "Email",
  "pointOfContact.enum.type.Fax": "Fax",
  "pointOfContact.enum.type.FaxVersion": "Fax",
  "pointOfContact.enum.type.Phone": "Phone",
  "pointOfContact.enum.type.PhoneVersion": "Phone",
  "pointOfContact.field.changeDate": "Change date",
  "pointOfContact.field.email": "Email",
  "pointOfContact.field.fax": "Fax",
  "pointOfContact.field.isValid": "Is valid",
  "pointOfContact.field.phone": "Phone",
  "pointOfContact.field.pointOfContact": "Point of contact",
  "pointOfContact.field.pointOfContacts": "Points of contact",
  "pointOfContact.field.type": "Type",
  "pointOfContact.field.value": "Contact information",
  "pointOfContact.title": "Points of contact",
  "policiesSection.title": "Policies",
  "policyInfoCard.fromDate": "Start date",
  "policyInfoCard.originalStartDate": "Original start date",
  "policyInfoCard.status": "Status",
  "policyInfoCard.title": "Policy info",
  "policyInfoCard.yearlyPensionableSalary": "Pensionable salary",
  "policyTabs.aiSummary.title": "AI summary",
  "policyTabs.policiesTab": "Policy details",
  "policyTabs.totalTab": "Total",
  "portfolio.actualFraction": "Actual fraction",
  "portfolio.advanced.view": "Advanced view",
  "portfolio.allTrades": "All trades",
  "portfolio.amount": "Amount",
  "portfolio.cash.fundName": "Fund name",
  "portfolio.cash.isinKey": "ISIN",
  "portfolio.cashValue": "Cash value",
  "portfolio.fund": "Fund",
  "portfolio.fundCostBalance": "Fund cost balance",
  "portfolio.fundName": "Fund name",
  "portfolio.history.view": "History view",
  "portfolio.investmentDetails": "Investment details",
  "portfolio.isinKey": "ISIN",
  "portfolio.notFound": "No portfolio was found for this participant.",
  "portfolio.profileTypes": "Profile types",
  "portfolio.real": "Savings",
  "portfolio.realWithoutYield": "Savings without yield",
  "portfolio.simple.view": "Simple view",
  "portfolio.statement.detailedView": "Detailed view",
  "portfolio.table.actual": "Actual",
  "portfolio.table.aggregatedData": "Aggregate",
  "portfolio.table.amounts": "Amounts",
  "portfolio.table.expected": "Expected",
  "portfolio.table.fraction": "Fraction",
  "portfolio.table.fundCashValuePrice": "Fund cash value",
  "portfolio.table.invested": "Invested",
  "portfolio.table.subPortfolioGroupKey": "Policy",
  "portfolio.table.subPortfolioKey": "Covers",
  "portfolio.table.sumOfUnits": "Sum of units",
  "portfolio.table.total": "Total",
  "portfolio.table.unitPrice": "Unit price",
  "portfolio.table.units": "Units",
  "portfolio.table.wanted": "Wanted",
  "portfolio.targetFraction": "Wanted fraction",
  "portfolio.trade.orders": "Trade orders",
  "portfolio.tradeAmount": "Amount",
  "portfolio.tradeCostBalance": "Trade cost balance",
  "portfolio.tradeCycleType": "Type",
  "portfolio.tradeDate": "Date",
  "portfolio.tradesOverview": "Trades",
  "portfolio.uninvested": "Investment account",
  "portfolio.unitPrice": "Unit price",
  "portfolio.units": "Units",
  "portfolio.view.areaChart": "Area chart",
  "portfolio.view.days": "Days",
  "portfolio.view.lineChart": "Line chart",
  "portfolio.view.months": "Months",
  "portfolio.view.years": "Years",
  "portfolio.yield": "Yield",
  "portfolio.yieldForCurrentYear": "Yield for current year",
  "portfolioCorrection.subPortfolioCorrection": "Choose cover",
  "portfolioCorrection.subPortfolioCorrections": "Cover level",
  "portfolioCorrectionModalButton.title": "Portfolio correction",
  "portfolioPage.commandsEmpty.informationMessage": "No portfolio found for {ownerId} in tenant {tenantId}",
  "portfolioTable.aggregated": "Aggregated view of policies",
  "postingEventCard.balanceDate": "Balance date",
  "postingEventCard.postingAmount": "Posting amount",
  "postingEventCard.postingSequenceNo": "Posting sequence no.",
  "postingEventCard.postingValueDate": "Posting value date",
  "postings.column.accountType": "Account type",
  "postings.column.amount": "Amount",
  "postings.column.companyId": "Company ID",
  "postings.column.coverKey": "Cover key",
  "postings.column.employerAgreementId": "Employer agreement ID",
  "postings.column.fromAndToDueDate": "Period",
  "postings.column.matchable": "Is matched?",
  "postings.column.moneyOutReceiver": "Receiver",
  "postings.column.policyKey": "Policy key",
  "postings.column.postingType": "Type",
  "postings.column.seqno": "Seq nr",
  "postings.column.tenantId": "Fund",
  "postings.column.tenantSubGroup": "Fund subgroup",
  "postings.column.transactionTime": "Transaction date",
  "postings.column.truncated": "Truncated",
  "postings.column.valueDate": "Value date",
  "postings.column.voucher": "Voucher",
  "postings.column.workPadRef": "Workpad",
  "postings.receiver": "Receiver",
  "postings.sender": "Sender",
  "postings.title": "Postings",
  "postings.voucher.companyId": "Company ID",
  "postings.voucher.creationStamp": "Creation timestamp",
  "postings.voucher.employerAgreementId": "Employer agreement ID",
  "postings.voucher.id": "ID",
  "postings.voucher.lifeInsuranceEvent": "lifeInsuranceEvent",
  "postings.voucher.moneyOutReceiver": "moneyOutReceiver",
  "postings.voucher.policyKey": "Policy key",
  "postings.voucher.policyProductType": "Policy product type",
  "postings.voucher.stamp": "Persisted timestamp",
  "postings.voucher.title": "Voucher for posting",
  "postings.voucher.traceId": "Trace ID",
  "postings.voucher.type": "Type",
  "postings.voucher.userId": "User ID",
  "premiumHolidaysPeriod.end": "End date",
  "premiumHolidaysPeriod.start": "Start date",
  "premiumHolidaysPeriod.title": "Premium Holiday",
  "pretendDeathModalButton.deathDate": "Death date",
  "pretendDeathModalButton.title": "Pretend death",
  "prognosis.deflated": "Deflated",
  "recurringPayments.endDate": "End date",
  "recurringPayments.heading": "Monthly payments",
  "recurringPayments.key": "Cover key",
  "recurringPayments.monthlyAmount": "Monthly amount",
  "recurringPayments.name": "Cover Name",
  "recurringPayments.personName": "Receiver",
  "recurringPayments.productType": "Type",
  "recurringPayments.startDate": "Start date",
  "relatedCommitment.name": "Name",
  "relatedCommitment.ssn": "SSN",
  "relatedCommitment.title": "Related commitments",
  "relatedInvoices.invoiceId": "Invoice ID",
  "relatedInvoices.originalAmount": "Original amount",
  "relatedInvoices.outstandingAmount": "Outstanding amount",
  "relatedInvoices.priority": "Priority",
  "relatedInvoices.title": "Related invoices",
  "relationshipInfo.noPartner": "No partner",
  "relationshipInfo.partnerStatus": "Partner status",
  "remove": "Remove",
  "reset": "Reset",
  "resumeInvoice.field.lastOperationDate": "Last operation date",
  "resumeInvoice.field.lastOperationId": "Last operation ID",
  "resumeInvoice.field.newDueDate": "New due date",
  "resumeInvoice.field.nextOperationDate": "Next operation date",
  "resumeInvoice.field.nextOperationId": "Next operation ID",
  "retirementDate.expectedRetirementDate": "Expected retirement date",
  "retirementDate.retirementDate": "Retirement date",
  "retirementPeriod.end": "End date",
  "retirementPeriod.start": "Start date",
  "returnPayment.title": "Return payment",
  "riskBenefitSpecVersion.moneyOuttype": "Money out type",
  "riskBenefitSpecVersion.noBenefit": "No benefit",
  "riskCoverDetails.billingAccountBalance": "Billing account balance",
  "riskCoverDetails.billingAccountId": "Billing account ID",
  "riskCoverDetails.claimAccountBalance": "Claim account balance",
  "riskCoverDetails.claimAccountId": "Claim account ID",
  "riskCoverDetails.coInsured": "Co-insured",
  "riskCoverDetails.coInsuredBirthDate": "Co-insured birthdate",
  "riskCoverDetails.coInsuredDeathDate": "Co-insured death date",
  "riskCoverDetails.coverLayerDetails": "Cover layer details",
  "riskCoverDetails.lifeInsuranceEvent": "Life insurance event",
  "riskCoverDetails.relationshipId": "Relationship ID",
  "riskCoverDetails.requiredRelationshipTypeForPayout": "Required relationship type for payout",
  "riskCoverDetails.riskBenefitSpecVersion": "Risk benefit spec",
  "riskCoverDetails.riskEndDate": "End date",
  "riskCoverDetails.title": "Risk cover",
  "riskCoverSimulation.title": "Risk covers",
  "rollbackForm.reason": "Reason",
  "rollbackForm.rollbackTo": "Recalculate to",
  "rowAction.download": "Download",
  "rowAction.view": "Details",
  "rowItem.enum.State.changed": "Changed",
  "rowItem.enum.State.deleted": "Deleted",
  "rowItem.enum.State.new": "New",
  "savingsContributionSpecDetails.closedforContribution": "Closed for contribution",
  "savingsContributionSpecDetails.contributionSpecFraction": "Fraction",
  "savingsContributionSpecDetails.contributionSpecPriority": "Priority",
  "savingsCoverDetails.expectedMoneyOutStartDate": "Expected money out start date",
  "savingsCoverDetails.relationshipId": "Relationship ID",
  "savingsCoverDetails.savingsAccount": "Savings account",
  "savingsCoverDetails.savingsAccountBalance": "Savings account balance",
  "savingsCoverDetails.savingsContributionSpecVersion": "Contribution spec",
  "savingsCoverDetails.savingsTaxCode": "Return taxation form",
  "savingsCoverDetails.title": "Savings cover",
  "savingsCoverSimulation.title": "Savings covers",
  "scenarioEventsList.noEvents": "No commands in this yet. Add commands using the command palette.",
  "scenarioHistory.applied": "Applied",
  "scenarioHistory.appliedBy": "Applied by",
  "scenarioHistory.cancelled": "Cancelled",
  "scenarioHistory.cancelledBy": "Cancelled by",
  "scenarioHistory.created": "Created",
  "scenarioHistory.createdBy": "Created by",
  "scenarioHistory.eventList.eventTitle": "Variant",
  "scenarioHistory.eventList.showInformation": "Show who created, applied or cancelled",
  "scenarioHistory.eventList.state": "State",
  "scenarioHistory.eventList.title": "Scenario variants",
  "scenarioHistory.filter.label": "Filter variants",
  "scenarioHistory.filter.onlyActionedByMe": "Only applied or cancelled by me",
  "scenarioHistory.noCommands": "This variant has no commands.",
  "scenarioHistory.notRecordedYet": "Not recorded yet",
  "scenarioHistory.selectVariant": "Pick a variant in the list to see its details and commands.",
  "scenarioHistory.title": "Scenario history",
  "scenarioHistory.untitledScenario": "Untitled scenario",
  "scenarioHistory.untitledVariant": "Untitled variant",
  "scenarioOverview.noCommands": "No commands.",
  "scenarioOverview.noScenariosExplainer": 'Create a new scenario by doing a command in the command palette where you click "{scenarioButton}" instead of "{applyButton}".',
  "scenarioOverview.noScenariosMatchSearch": "No scenarios match your search.",
  "scenarioOverview.noVariantsAvailable": "No variants available.",
  "scenarioOverview.scenarioCountLabel": "{count} scenarios exist",
  "scenarioOverview.searchPlaceholder": "Search scenarios and variants",
  "scenarioOverview.selectedLabel": "{scenarioTitle}, {variantTitle}",
  "scenarios.actions.apply": "Apply",
  "scenarios.actions.copyVariant": "Copy",
  "scenarios.actions.deleteScenario": "Delete scenario",
  "scenarios.actions.deleteVariant": "Delete variant",
  "scenarios.actions.editScenario": "Edit scenario",
  "scenarios.actions.editVariant": "Edit variant",
  "scenarios.current": "Current",
  "scenarios.current.diffingDisabled.noCommitment": "Diffing is disabled as the participant does not have a commitment.",
  "scenarios.current.selectForCompare": "Compare with current",
  "scenarios.leave": "Leave scenario",
  "scenarios.simulationDate": "Simulation date",
  "scenarios.title": "Scenarios",
  "search.categories.pages.agreement": "Agreements",
  "search.categories.pages.changes": "Changes",
  "search.categories.pages.company": "Company",
  "search.categories.pages.health": "Health",
  "search.categories.pages.incomingPayment": "Incoming payments",
  "search.categories.pages.outgoingPayment": "Outgoing payments",
  "search.categories.pages.person": "Person",
  "search.categories.pages.policy": "Policies",
  "search.categories.pages.portfolio": "Portfolio",
  "search.categories.pages.tax": "Tax reports",
  "search.categories.recent.lastWeek": "Last week",
  "search.categories.recent.older": "Older",
  "search.categories.recent.today": "Today",
  "search.categories.recent.yesterday": "Yesterday",
  "search.entityNoInformation": "No information can be shown for this {entity}. This can be due to it not existing in the system yet. Or that the entity may be in stop.",
  "search.lookupExternalId": "Search {id}…",
  "searchEntity.address": "Address",
  "searchEntity.agreements": "Agreements",
  "searchEntity.amount": "Amount",
  "searchEntity.birthDate": "Birth date",
  "searchEntity.deathDate": "Death date",
  "searchEntity.externalId": "External ID",
  "searchEntity.gender": "Gender",
  "searchEntity.internalId": "Internal ID",
  "searchEntity.lookup.allAccessDenied": "You do not have access to view any of the results.",
  "searchEntity.lookup.notFound": "No results found.",
  "searchEntity.lookup.partialAccessDenied": "You do not have access to view all of the results.",
  "searchEntity.navigate": "Navigate",
  "searchEntity.payer": "Payer",
  "searchForm.search": "Search",
  "searchInput.birthDate": "Birth date",
  "searchInput.email": "E-mail",
  "searchInput.firstName": "First name",
  "searchInput.lastName": "Last name",
  "searchInput.phoneNumber": "Phone number",
  "searchNotFound.message": "Nothing was found. Please try again, or refine your search below.",
  "searchResultsCard.column.address": "Address",
  "searchResultsCard.column.birthDate": "Birth date",
  "searchResultsCard.column.emails": "E-mails",
  "searchResultsCard.column.name": "Name",
  "searchResultsCard.column.phoneNumbers": "Phone numbers",
  "searchResultsCard.title": "Results",
  "setCommitmentTime.dateTime": "Date and time",
  "setCommitmentTime.doNotCatchUp": "Do not catch up",
  "setCommitmentTime.form.warning": "Setting the date manually will make this commitment unable to follow the time of the system component!",
  "setCommitmentTime.title": "Commitment time",
  "showInstallments.amount": "Amount",
  "showInstallments.dueDate": "Due date",
  "simulation.showDiffing": "Show diffing",
  "skipAutoHandlingCommitmentSourceExternalPayloadModalButton.title": "Skip auto handling of commitment source external payload",
  "specifications.column.action.moveToExternalHandling": "Move to external handling",
  "specifications.column.amount": "Amount",
  "specifications.column.reference": "Reference",
  "specifications.column.uniqueNtryRef": "Entry ref",
  "specifications.column.valueDate": "Paid",
  "status.stopped": "Stopped",
  "stopAlert.invoiceCreation": "Invoice creation",
  "stopEvents.applicationVersion": "Application version",
  "stopEvents.applyStop": "Applying commands stopped",
  "stopEvents.changedBy": "Changed by",
  "stopEvents.communicationStop": "Communications stopped",
  "stopEvents.configurationVersionNumber": "Configuration version number",
  "stopEvents.creationStamp": "Creation stamp",
  "stopEvents.date": "Date",
  "stopEvents.errorApplyStop": "Applying commands stopped due to errors",
  "stopEvents.fullStop": "Full stop",
  "stopEvents.reason": "Reason",
  "stopEvents.stackTraceDetails": "Technical details about reason for stop (stacktrace)",
  "stopEvents.title": "Stop history",
  "subPortfolioCorrection.amount": "Amount",
  "subPortfolioCorrection.coverKey": "Cover key",
  "subPortfolioCorrection.fundCorrection": "Choose fund",
  "subPortfolioCorrection.fundCorrections": "Fund level",
  "subPortfolioCorrection.policyKey": "Policy key",
  "subPortfolioEmployment.helpText": "Customer policy view",
  "subPortfolioKeyInputs.resetSubPortfolioKeys": "Reset sub portfolio keys",
  "subPortfolioKeyInputs.subPortfolioGroupKey": "Effect on policy",
  "subPortfolioKeyInputs.subPortfolioKey": "Effect on cover",
  "switchSubPortfolioForm.subPortfolioKeys": "Covers to switch",
  "switchSubPortfolioForm.switchCommandType": "Switch type",
  "switchSubPortfolioGroupForm.resetSubPortfolioKeys": "Reset sub-portfolio keys",
  "switchSubPortfolioGroupForm.subPortfolioGroupKeys": "Customer policies to switch",
  "switchSubPortfolioGroupForm.switchCommandType": "Switch command type",
  "switchSubPortfolioGroupModalButton.title": "Switch portfolio for customer policy",
  "switchSubPortfolioModalButton.title": "Switch portfolio for covers",
  "switchTradeModalButton.fundSelection": "Fund selection",
  "switchTradeModalButton.fundSelection.isinKey": "ISIN key",
  "switchTradeModalButton.fundSelection.percentage": "Percentage",
  "switchTradeModalButton.fundSelections": "Fund selections",
  "switchTradeModalButton.profileType": "Profile type",
  "switchTradeModalButton.rebalance": "Rebalance",
  "switchTradeModalButton.title": "Switch trade",
  "switchTradeModalButton.updateProfile": "Update profile",
  "timeModal.addDay": "+1 day",
  "timeModal.addMonth": "+1 month",
  "timeModal.addYear": "+1 year",
  "timeModal.setTime": "Set time",
  "timeModal.title": "System time",
  "timeline.commandLane.applyDate": "Apply date",
  "tradeCycle.buyPrice": "Buy price",
  "tradeCycle.cycle.amount": "Amount",
  "tradeCycle.cycle.assetManagerId": "Asset manager ID",
  "tradeCycle.cycle.events": "Events",
  "tradeCycle.cycle.isinKey": "ISIN keys",
  "tradeCycle.cycle.title": "Trade cycle",
  "tradeCycle.cycle.type": "Type",
  "tradeCycle.cycle.units": "Units",
  "tradeCycle.fundName": "Fund name",
  "tradeCycle.isinkey": "ISIN",
  "tradeCycle.sellPrice": "Sell price",
  "tradeCycle.tradeOrderStatus.acknowledged": "Acknowledged",
  "tradeCycle.tradeOrderStatus.allPricesReceived": "All prices received",
  "tradeCycle.tradeOrderStatus.assetManagerId": "Asset manager ID",
  "tradeCycle.tradeOrderStatus.fundPriceStatus.notReceived": "{isin} (not received)",
  "tradeCycle.tradeOrderStatus.fundPriceStatus.received": "{isin} (received)",
  "tradeCycle.tradeOrderStatus.fundPriceStatuses": "Fund price statuses",
  "tradeCycle.tradeOrderStatus.orderId": "Order ID",
  "tradeCycle.tradeOrderStatus.sent": "Sent",
  "tradeCycle.tradePrices": "Trade prices",
  "tradeCycleOverview.fromTime": "Stamp",
  "tradeCycleOverview.status": "Status",
  "tradeCycleOverview.title": "Trade cycles",
  "tradeCycleOverview.tradeCycleType": "Type",
  "type.enum.Address.AbroadAddress": "Abroad",
  "type.enum.Address.Address": "Address",
  "type.enum.Address.InformalAddress": "Informal",
  "unitlinkCoverVoucher.amount": "Amount",
  "unitlinkCoverVoucher.coverKey": "Cover key",
  "unitlinkCoverVoucher.policyKey": "Policy key",
  "unitlinkCoverVoucher.profileType": "Profile type",
  "update": "Update",
  "updateBalance.calculationDate": "Calculation date",
  "updateBalance.description": "This will calculate and update the UnitLink balance for the portfolio.",
  "updateBalance.title": "Balance update for all policies",
  "updateCommitmentSourceExternalPayloadModalButton.postingId": "Posting",
  "updateCommitmentSourceExternalPayloadModalButton.title": "Update commitment source external payload",
  "updateCommunicationPreference.field.changeDate": "Change date",
  "updateCommunicationPreference.field.communicationPreferenceType": "Communication preference",
  "updateCommunicationPreference.title": "Communication preference",
  "updateCompanyName.button": "Company name",
  "updateCompanyName.name": "Name",
  "updatePartnerButton.buttonAdd": "Partner",
  "updatePartnerButton.buttonUpdate": "Partner update",
  "updatePartnerButton.changeDate": "Change date",
  "uploadHistoricalInputsModal.action": "Upload historical inputs",
  "userSettings.enum.theme.dark": "Dark",
  "userSettings.enum.theme.light": "Light",
  "userSettings.enum.theme.system": "System",
  "userSettings.user": "User",
  "validation.companyId": "Company ID could not be found",
  "validation.enabled": "Validate form",
  "validation.ssn": "SSN could not be found",
  "validationMessage.overrideButtonText": "Override",
  "validationMessage.overrideMessage": "Override message",
  "validationOverridesInEffect.key": "Key",
  "validationOverridesInEffect.reason": "Override reason",
  "validationOverridesInEffect.title": "Validation overrides",
  "viewPaymentModal.invoiceId": "Invoice ID",
  "viewPaymentModal.paymentType.ReturnedPayment": "Returned payment",
  "viewPaymentModal.paymentType.invoicePayment": "Invoice payment",
  "viewPaymentModal.paymentType.settledPayment": "Settled payment",
  "viewPaymentModal.paymentType.splitPayment": "Split payment",
  "viewPaymentModal.paymentUsage": "Usage",
  "viewPaymentModal.paymentUsageType": "Usage type",
  "viewPaymentModal.settledWithPaymentId": "Settled with payment ID",
  "viewPaymentModal.splitToPaymentIds": "Split to payment IDs",
  "viewPaymentModal.userId": "User ID",
  "workPad.creationStamp": "Created",
  "workPad.title": "Workpad",
  "workPad.userId": "Created by",
} as const
